import { render, staticRenderFns } from "./WithdrawalHistoryTab.vue?vue&type=template&id=083babac&"
import script from "./WithdrawalHistoryTab.vue?vue&type=script&lang=js&"
export * from "./WithdrawalHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports